import styled from 'styled-components';
import GuideBox from '../components/guide/GuideBox';

const searchGuideList = [
  {
    title: '1. 경매종합검색',
    description: `사건번호부터 특수조건까지 원하는 조건으로\n전국의 맞춤 경매 물건을 찾을 수 있습니다.`,
    subDescription:
      '내 검색조건 만들기 기능으로 자주 사용하는 검색 조건을 저장해서 쉽고 편하게 경매 물건을 찾아보세요!',
    urls: [
      {
        title: '경매종합검색',
        url: '/search?type=c',
      },
    ],
    img: '/assets/images/guide/Guide_01_1.png',
  },
  {
    title: '2. 일정별 검색',
    description: `경매 물건을 일정별로 찾아보세요!`,
    subDescription:
      '신건부터 예정물건 그리고 낙찰 결과 통계까지 한 눈에 보기 쉽게 제공해드립니다.',
    urls: [
      {
        title: '경매 신건',
        url: '/NewAuction',
      },
      {
        title: '경매 일정',
        url: '/auctionSchedule',
      },
    ],
    img: '/assets/images/guide/Guide_01_2.png',
  },
  {
    title: '3. 지역기반 검색',
    description: `법원별, 소재지별 관심 있는 지역을 기준으로\n경매·공매 물건을 탐색할 수 있습니다.`,
    subDescription:
      '관할 법원 또는 소재지(시/군/구 등)를 선택해 원하는 지역 범위 내의 물건만 빠르게 조회할 수 있습니다.',
    urls: [],
    img: '/assets/images/guide/Guide_01_3.png',
    onlyPc: true,
  },
  {
    title: '4. 특수·테마 검색',
    description: '',
    subDescription:
      '공매, 특수물건, NPL, 채권거래소 등 다양한 맞춤 검색으로 더 폭넓은 투자 전략을 세워보세요.',
    urls: [],
    img: '/assets/images/guide/Guide_01_4.png',
    onlyPc: true,
  },
  {
    title: '5. 지도 검색',
    description: `전국에 어떤 물건이 있는지 지도로 쉽게 파악하고,\n클릭 한 번으로 바로 확인하세요.`,
    subDescription:
      '관련 물건을 모아서 볼 수 있고, 예정 물건까지 쉽게 파악돼 한눈에 비교가 가능합니다.',
    urls: [
      {
        title: '지도 검색',
        url: '/map',
      },
    ],
    img: '/assets/images/guide/Guide_01_5.png',
  },
];
function SearchGuide() {
  return (
    <Box gap={64}>
      {searchGuideList.map((props, index) => (
        <GuideBox key={index} {...props} />
      ))}
    </Box>
  );
}

export default SearchGuide;

const Box = styled.div<{ gap?: number }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;
